import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  setFromLastPage
} from '../store/actions/criteria-actions';


const InsightsNavBar = ({ selectedReport }) => {

  const reportLinks = useSelector(state => state.reports.reportLinks);
  const dispatch = useDispatch();

  return (
  <nav className="InsightsNavBar">
    <ul className="InsightsNavBar_ul">
      {reportLinks.map(report => (
        <li className="InsightsNavBar_li" key={report.id}>
          {report.available === true && report.path ? (
            <Link
              to={report.path}
              className={`InsightsNavBar_link${
                report.id === selectedReport
                  ? ' InsightsNavBar_link_selected'
                  : ''
              }`}
              onClick={() => dispatch(setFromLastPage(window.location.pathname))}
            >
              {report.name}
            </Link>
          ) : (
            <div className="InsightsNavBar_disabled-link">
              {report.name}{' '}
              <span className="screen-reader">(report not available)</span>
            </div>
          )}
        </li>
      ))}
    </ul>
  </nav>
)};

InsightsNavBar.propTypes = {
  selectedReport: PropTypes.string.isRequired,
};

export default InsightsNavBar;
